<template>
  <div>
    <v-row class="mb-7">
      <v-col lg="6" class="py-0">
        <v-toolbar flat style="background: transparent">
          <h2>Live Report</h2>
        </v-toolbar>
      </v-col>
      <v-col lg="6" class="py-0">
        <v-toolbar flat style="background: transparent" class="content-right">
          <v-btn
          @click="goToCourseDetail"
          elevation="0"
          class="pl-5 pr-5 xs-full-width font-weight-light button-primary white--text"
        >
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.courseReport.courseDetail'
            )
          }}
        </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>
    <div class="bg-custom py-7">
      <v-row class="mb-5">
        <v-col lg="12">
          <v-toolbar flat style="background: transparent">
            <div class="mt-7">
              <p class="mb-2 caption font-weight-medium text-caption">
                เลือกการถ่ายทอดสด
              </p>
              <v-select
                v-model="liveSelect"
                :items="live_item"
                item-text="title"
                item-value="_id"
                placeholder="กรุณาเลือกการถ่ายทอดสด"
                background-color="white"
                outlined
                @change="filterReport"
              ></v-select>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              @click="onExport"
              class="
                clickable
                pl-5
                pr-5
                mr-5
                xs-full-width
                font-weight-light
                body-2
                button-secondary
                v-btn
                theme--light
                elevation-0
                v-size--default
              "
            >
              <v-icon left class="icon-color-inherit"
                >mdi-microsoft-excel</v-icon
              >{{
                $vuetify.lang.t('$vuetify.courseManagement.courseReport.export')
              }}
            </v-btn>
          </v-toolbar>
        </v-col>
        <!--<v-col class="ml-5 xs-full-width text-right">
                
            </v-col>-->
      </v-row>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items-per-page="params.limit"
        hide-default-footer
        :items="users"
        class="pa-mb-5 mx-3 font-weight-light table-haveboder"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <template v-for="(item, index) in items">
              <tr :key="index">
                <td
                  :rowspan="
                    item.history.length > 1 ? item.history.length + 1 : ''
                  "
                  valign="top"
                >
                  {{ item.prefix }}
                </td>
                <td
                  :rowspan="
                    item.history.length > 1 ? item.history.length + 1 : ''
                  "
                  valign="top"
                >
                  {{ item.fullName }}
                </td>
                <td
                  :rowspan="
                    item.history.length > 1 ? item.history.length + 1 : ''
                  "
                  valign="top"
                >
                  {{ item.username }}
                </td>
                <td
                  :rowspan="
                    item.history.length > 1 ? item.history.length + 1 : ''
                  "
                  valign="top"
                  class="have-boder-right"
                >
                  {{ item.email }}
                </td>
                <td
                  :rowspan="
                    item.history.length > 1 ? item.history.length + 1 : ''
                  "
                  valign="top"
                  class="have-boder-right"
                >
                  {{ item.note }}
                </td>
                <td
                  class="text-center"
                  colspan="4"
                  v-show="
                    item.history.length == 1 &&
                    item.history[0].platform === null
                  "
                >
                  ยังไม่มีประวัติ
                </td>

                <td
                  v-show="
                    item.history.length == 1 &&
                    item.history[0].platform !== null
                  "
                >
                  {{ item.history[0].startTime | moment('DD/MM/YYYY HH:mm') }}
                </td>
                <td
                  v-show="
                    item.history.length == 1 &&
                    item.history[0].platform !== null
                  "
                >
                  {{ item.history[0].endTime | moment('DD/MM/YYYY HH:mm') }}
                </td>
                <td
                  v-show="
                    item.history.length == 1 &&
                    item.history[0].platform !== null
                  "
                >
                  {{
                    item.history[0].platform === null
                      ? '-'
                      : item.history[0].platform
                  }}
                </td>
                <td
                  v-show="
                    item.history.length == 1 &&
                    item.history[0].platform !== null
                  "
                >
                  {{
                    item.history[0].platform === null
                      ? '-'
                      : item.history[0].device
                  }}
                </td>
              </tr>
              <tr
                v-for="(item_history, index_history) in item.history"
                :key="index_history"
                v-show="item.history.length > 1"
              >
                <td>
                  {{ item_history.startTime | moment('DD/MM/YYYY HH:mm') }}
                </td>
                <td>{{ item_history.endTime | moment('DD/MM/YYYY HH:mm') }}</td>
                <td>{{ item_history.platform }}</td>
                <td>{{ item_history.device }}</td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-data-table>
      <div class="pt-3 pr-3 pb-5 text-center">
        <v-pagination
          v-model="params.page"
          :length="pageCount"
          @input="changePage"
          color="rgb(66, 154, 216)"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import moment from 'moment';
import { getCourseById } from '@/service/course/course';
import { getHistoryReport } from '@/service/course/report';
export default {
  data() {
    return {
      loading: false,
      json: [
        {
          name: 'Dady',
          age: '21',
        },
        {
          name: 'Jonh',
          age: '25',
        },
        {
          name: 'James',
          age: '17',
        },
      ],
      // items: [{
      //     id: 'text',
      //     text: 'live 1'
      // }],
      headers: [
        {
          text: 'PREFIX',
          value: 'prefix',
          align: 'start',
          sortable: false,
        },
        {
          text: 'NAME',
          value: 'fullName',
          align: 'start',
          sortable: false,
        },
        {
          text: 'USERNAME',
          align: 'start',
          sortable: false,
          value: 'username',
        },

        {
          text: 'EMAIL',
          value: 'email',
          align: 'start',
          sortable: false,
        },
        {
          text: 'NOTE',
          value: 'note',
          align: 'start',
          sortable: false,
        },
        {
          text: 'Start Time',
          value: 'start',
          align: 'start',
          sortable: false,
        },

        {
          text: 'End Time',
          value: 'end',
          align: 'start',
          sortable: false,
        },
        {
          text: 'Platform',
          value: 'platform',
          align: 'start',
          sortable: false,
        },
        {
          text: 'Device',
          value: 'device',
          align: 'start',
          sortable: false,
          width: '150px',
        },
      ],
      params: {},
      live_item: [],
      liveSelect: '',
      users: [],
      courseName: '',
    };
  },
  methods: {
    async onExport() {
      let result = await getHistoryReport({
        ...this.params,
        limit: 5000,
        page: 1,
      });
      console.log('result', result);
      let users = [];
      await result.data.forEach(async (user) => {
        for (let i = 0; i < user.history.length; i++) {
          let info = {
            prefix: user.student.prefix,
            username: user.student.username,
            fullName: user.student.firstName + ' ' + user.student.lastName,
            email: user.student.email,
            note: user.student.school,
            startTime: user.history[i].startTime
              ? moment(user.history[i].startTime).format('DD/MM/YYYY HH:mm')
              : '-',
            endTime: user.history[i].endTime
              ? moment(user.history[i].endTime).format('DD/MM/YYYY HH:mm')
              : '-',
            platform: user.history[i].platform,
            device: user.history[i].device,
          };

          users.push(info);
        }
        // users.push({
        //     id: user.student._id,
        //     fullName: user.student.firstName + " " + user.student.lastName,
        //     email: user.student.email,
        //     username: user.student.username,
        //     history: user.history,
        // });
      });

      const dataWS = XLSX.utils.json_to_sheet(users);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, this.courseName + `_` + `LiveReport` + `.xlsx`);
    },
    async initialize() {
      let date = {
        date_end: new Date().toISOString().substr(0, 10),
        hh_start: new Date().getHours(),
        mm_start: new Date().getMinutes(),
      };
      let end = date.date_end + ' ' + date.hh_start + ':' + date.mm_start;
      console.log('start', end);
      let end_time = Math.floor(new Date(end).getTime());
      this.params = {
        sort: 'created_at',
        sortby: -1,
        page: 1,
        limit: 25,
        active: null,
        idlivestream: '',
        datelivestream: [
          {
            starttime: 0,
            endtime: end_time,
          },
        ],
      };
      let course = {
        id: this.$route.query.id,
      };
      await this.getCourseDetail(course);
      // await this.getOndemandReport();
    },
    async getCourseDetail(param) {
      this.live_item = [];
      let lecture_arr = [];

      let detail = await getCourseById(param);
      this.courseName = detail ? detail.title : 'live';
      console.log('detail', detail);

      console.log('lecture_arr', lecture_arr);
      let liveStream =
        detail.Live_LivestreamsV2.length > 0
          ? detail.Live_LivestreamsV2
          : detail.livestreams;
      this.live_item = liveStream;
      this.liveSelect = liveStream[0]._id;
      this.params.idlivestream = liveStream[0]._id;
      await this.getReport();
    },
    async getReport() {
      this.users = [];
      this.loading = true;
      let result = await getHistoryReport(this.params);

      console.log(result);
      this.pageCount = result.maxPage;
      await result.data.forEach(async (user) => {
        this.users.push({
          id: user.student._id,
          prefix: user.student.prefix,
          fullName: user.student.firstName + ' ' + user.student.lastName,
          email: user.student.email,
          note: user.student.school,
          username: user.student.username,
          history: user.history,
        });
      });
      this.loading = false;
    },
    async changePage(page) {
      this.params.page = page;
      await this.getReport();
    },
    async filterReport() {
      this.params = {
        ...this.params,
        page: 1,
        idlivestream: this.liveSelect,
      };
      await this.getReport();
      // let result = await getReport(this.params);
      // console.log(result);
    },
    goToCourseDetail(){
      this.$router.push({
        path: '/course/detail',
        query: {
          id: this.$route.query.id,
          step: 1,
        },
      });
    }
  },
  async mounted() {
    await this.initialize();
  },
};
</script>

<style scoped>
.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}

td {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

th {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
<style lang="scss">
  .content-right {
    .v-toolbar__content, .v-toolbar__extension {
      justify-content: flex-end;
    }
  }
</style>
